var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/jsx-no-useless-fragment */
import React, { useRef } from 'react';
import cn from 'classnames';
import { useLoginStatus } from './useLoginStatus';
export const hLevel = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
export const skipEnrollOpt = ['Y', ''];
export const IdentityCardHeading = (_a) => {
    var { headingLevel, children } = _a, props = __rest(_a, ["headingLevel", "children"]);
    const Heading = headingLevel;
    return React.createElement(Heading, Object.assign({}, props), children);
};
export const IdentityCard = (_a) => {
    var { loginUrl = 'https://account.collegeboard.org/login/login', createAccountUrl = 'https://account.collegeboard.org/login/signUp', appId, destinationUrl, isStudent, skipEnroll, loggedInComponent = null, className, headingLevel = 'h2', headingTitle = 'Sign In', topDesc = (React.createElement(React.Fragment, null,
        "Sign in to personalize your visit and ",
        React.createElement("br", null),
        "access your College Board account.")), primaryBtnLabel = 'Continue', secondaryBtnLabel = 'Create Account', bottomDesc = React.createElement(React.Fragment, null, "Don\u2018t have an account?") } = _a, props = __rest(_a, ["loginUrl", "createAccountUrl", "appId", "destinationUrl", "isStudent", "skipEnroll", "loggedInComponent", "className", "headingLevel", "headingTitle", "topDesc", "primaryBtnLabel", "secondaryBtnLabel", "bottomDesc"]);
    let oktaUrl = `${loginUrl}?appId=${appId}`;
    if (destinationUrl) {
        oktaUrl += `&DURL=${encodeURI(destinationUrl)}`;
    }
    if (skipEnroll) {
        oktaUrl += `&skipEnroll=${skipEnroll}`;
    }
    oktaUrl += `${isStudent !== undefined ? `&idp=${isStudent ? 'ECL' : 'EPL'}` : ''}`;
    const { isLoggedIn } = useLoginStatus();
    const anchorRef = useRef(null);
    const btnRef = useRef(null);
    const cardClass = cn('cb-card', 'cb-identity-card', 'cb-align-center', className);
    const a11YKeydown = (e, node) => {
        const k = e.which || e.keyCode;
        // space or enter
        if (k === 32) {
            e.preventDefault();
            node && node.current.click();
        }
    };
    return (React.createElement(React.Fragment, null, isLoggedIn ? (loggedInComponent) : (React.createElement("div", Object.assign({ className: cardClass, "data-cbtrack-comp": "apricot-react:card" }, props),
        React.createElement("div", { className: "cb-identity-card-container" },
            React.createElement(IdentityCardHeading, { headingLevel: headingLevel, className: "cb-paragraph6-st display-inline-flex" }, headingTitle),
            React.createElement("p", { className: "cb-margin-top-8 cb-roboto-light cb-align-center" }, topDesc),
            React.createElement("a", { ref: btnRef, href: oktaUrl, role: "button", className: "cb-btn cb-btn-primary cb-margin-top-16", onKeyDown: e => a11YKeydown(e, btnRef) }, primaryBtnLabel),
            createAccountUrl && (React.createElement("div", { className: "cb-margin-top-32 cb-padding-top-16 cb-border-top-1 cb-border-dashed cb-gray4-border" },
                React.createElement("p", { className: "cb-margin-top-8 cb-roboto-light cb-align-center" }, bottomDesc),
                React.createElement("a", { ref: anchorRef, href: createAccountUrl, className: "cb-link-black cb-roboto-medium display-block cb-align-center", role: "button", onKeyDown: e => a11YKeydown(e, anchorRef) }, secondaryBtnLabel))))))));
};
//# sourceMappingURL=identity-card.js.map